import { API } from 'aws-amplify';

export const read = async () => API.get('robinhoodEngGuestApi', '/animals', {});

export const readOne = async (id) => API.get('robinhoodEngGuestApi', `/animals/${id}`, {});
